import React, { forwardRef } from 'react';
import clsx from 'clsx';

const FormPassword = forwardRef((props, ref) => {
  const {
    className,
    ...rest
  } = props;
  const classes = clsx('form-item form-item--password', className);
  return (
    <input
      ref={ref}
      {...rest}
      className={classes}
      type="password"
    />
  );
});

export default FormPassword;
